import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import styled from "styled-components";
import TranslateIcon from '@material-ui/icons/Translate';
import useWindowSize from "src/pages/hooks/useWindowSize";

const Root = styled.div`
    display: flex;
    .split-button {
        font-size: 13px;
    }
    .MuiListItem-root {
        font-size: 13px;
    }
    .MuiButtonBase-root .MuiButton-label .color {
        font-size: 13px;
    }
`;

const StyledPopper = styled(Popper)`
    z-index:100;
`;

const StyledButton = styled((props: any) => <Button className={props.className} onClick={props.onClick}>{props.children}</Button>)`
    svg {
        color: ${props => props.theme.primaryColor};
    }
    ${props => props.revertColorForDesktop ? '@media (min-width: 992px) { svg { color: white;}}' : ''}
`;

export interface SplitButtonsProps {
    onClickItems: Function;
    disabled: boolean;
    value: number;
    options: string[];
    buttonName?: string;
    className?: string;
    isLanguage?: boolean;
    alwaysSmall?: boolean;
    onMainButtonClick?: Function;
    ifOneHideArrow?: boolean;
    revertColorForDesktop?: boolean;
}

export default function SplitButton(props: SplitButtonsProps) {
    const [width] = useWindowSize();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        index: number,
    ) => {
        props.onClickItems(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return;
        }
        setOpen(false);
    };

    return (
        <Root className={props.className} ref={anchorRef}>
            {(props.isLanguage && width < 993) || props.alwaysSmall ?
              <StyledButton onClick={handleToggle} revertColorForDesktop={props.revertColorForDesktop}>
                  <TranslateIcon/>
              </StyledButton>
              :
              <ButtonGroup disabled={props.disabled} variant="contained" aria-label="split button">
                  <Button className={"split-button"} onClick={() => {
                      if (props.onMainButtonClick) props.onMainButtonClick();
                  }}>
                      <div className={"color"}>{props.buttonName ? props.buttonName : props.options[props.value]}</div>
                  </Button>
                  {
                      (props.ifOneHideArrow && props.options.length === 1) 
                          ? false
                          :
                              <Button
                                  className={"split-button"}
                                  size="small"
                                  aria-controls={open ? 'split-button-menu' : undefined}
                                  aria-expanded={open ? 'true' : undefined}
                                  aria-label="select merge strategy"
                                  aria-haspopup="menu"
                                  onClick={handleToggle}
                              >
                                  <div className={"color"}><ArrowDropDownIcon/></div>
                              </Button>
                  }
              </ButtonGroup>
            }
            <StyledPopper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu">
                                    {props.options.map((option, index) => (
                                        <MenuItem
                                            key={option}
                                            selected={index === props.value}
                                            onClick={(event) => handleMenuItemClick(event, index)}
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </StyledPopper>
        </Root>
    );
}